import { DEFAULT_EQUIPMENT_TYPE_OPTIONS } from "../../constants";
import { MultiSelect } from "../Select";
import { ALL_OPTION } from "./constants";

import type { SelectProps } from "@mui/material";

interface Props {
  onChange: (value: string[]) => void;
  showAllOption?: boolean;
  defaultValue?: string[];
  value?: string[];
  customOptions?: EquipmentOption[];
  width?: string;
  selectProps?: SelectProps;
  label?: string;
}

export function EquipmentTypeMultiSelect(props: Props) {
  const {
    onChange,
    showAllOption = false,
    defaultValue = [],
    value,
    customOptions,
    width,
    selectProps,
    label,
  } = props;

  let options = DEFAULT_EQUIPMENT_TYPE_OPTIONS;
  if (customOptions) {
    options = customOptions;
  }

  return (
    <MultiSelect
      inputLabel={label ?? "Equipment Types"}
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      options={showAllOption ? ALL_OPTION.concat(options) : options}
      width={width}
      selectProps={selectProps}
    />
  );
}
